import { render, staticRenderFns } from "./ToTopFaq.vue?vue&type=template&id=b9559a1c&scoped=true&"
import script from "./ToTopFaq.vue?vue&type=script&lang=js&"
export * from "./ToTopFaq.vue?vue&type=script&lang=js&"
import style0 from "./ToTopFaq.vue?vue&type=style&index=0&id=b9559a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9559a1c",
  null
  
)

export default component.exports